var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirecticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 5.02344L10.2133 0.923437M10.6133 2.92344V0.523438H8.21328M5.11328 0.523438H4.11328C1.61328 0.523438 0.613281 1.52344 0.613281 4.02344V7.02344C0.613281 9.52344 1.61328 10.5234 4.11328 10.5234H7.11328C9.61328 10.5234 10.6133 9.52344 10.6133 7.02344V6.02344",
    stroke: "#5F5F5F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirecticon);
export default __webpack_public_path__ + "static/media/redirecticon.1df6b62e61a086504b26ff037285ac43.svg";
export { ForwardRef as ReactComponent };